import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-slate-950 text-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-113">
      {/* Background glow effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-blue-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-114"></div>

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-115">
        <div className="inline-block bg-slate-800/80 border border-slate-700 text-amber-400 font-semibold px-4 py-1.5 rounded-full text-sm md:text-base mb-8 uppercase tracking-wider" data-id="element-116">
          Para hombres y mujeres de 40 a 50 años con dolor de ciática
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-117">
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-300" data-id="element-118">
            CIÁTICA SOS:
          </span>
          <span className="block text-3xl md:text-4xl lg:text-5xl mt-2 text-blue-400" data-id="element-119">
            El Protocolo de 7 Minutos desde la Cama
          </span>
        </h1>

        <p className="text-xl md:text-2xl lg:text-3xl font-bold text-orange-400 mb-12 max-w-3xl mx-auto leading-snug" data-id="element-120">
          Desactiva el "latigazo" eléctrico y vuelve a caminar sin dolor antes
          de que tus pies toquen el suelo.
        </p>

        <div className="relative max-w-2xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl shadow-blue-900/20 border border-slate-800" data-id="element-121">
          <img src="https://cdn.magicpatterns.com/uploads/dqkJd8tBDg8ujKm4jGTLAZ/heylloyd-image-1772239487792.png" alt="Ciática SOS Protocolo en múltiples dispositivos" className="w-full h-auto object-cover" data-id="element-122" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 to-transparent flex items-end justify-center pb-6" data-id="element-123">
            <p className="text-white font-bold text-lg drop-shadow-md" data-id="element-124">
              Acceso Inmediato Digital
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-125">
          <CTAButton data-id="element-126">¡SÍ! QUIERO ALIVIO EN 7 MINUTOS AHORA</CTAButton>
          <p className="text-slate-400 text-sm mt-4 flex items-center gap-2" data-id="element-127">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-128"></span>
            Funciona esta misma noche
          </p>
        </div>
      </div>
    </section>;
}